import { useCallback } from 'react'
import { API, API_ROUTER } from '../../../../../api'

/**
 * Custom hook for fetching authenticated tournaments data
 * @param {Object} params - Hook parameters
 * @param {number} params.pageTournament - Current page number
 * @param {Object} params.defaultGame - Selected game filter
 * @param {Object} params.defaultMonth - Selected month filter
 * @param {Function} params.setTournamentList - Function to set tournament list state
 * @param {Function} params.setIsLoading - Function to set loading state
 * @param {Function} params.setIsFilterLoading - Function to set filter loading state
 * @returns {Object} Hook utilities and functions
 */
export const useGetAuthTournament = ({
  pageTournament,
  defaultGame,
  defaultMonth,
  setTournamentList,
  setIsLoading,
  setIsFilterLoading,
}) => {
  /**
   * Fetch authenticated tournaments data
   * @param {boolean} isFilterChange - Whether this is a filter change request
   */
  const getAuthTournament = useCallback(
    (isFilterChange = false) => {
      if (isFilterChange) {
        setIsFilterLoading(true)
      } else {
        setIsLoading(true)
      }

      const urlParams = {}

      if (defaultMonth?.startedFromDate && defaultMonth?.startedToDate) {
        urlParams['startedFromDate'] = defaultMonth.startedFromDate
        urlParams['startedToDate'] = defaultMonth.startedToDate
      }

      if (defaultGame?.id) {
        urlParams['gameId'] = defaultGame?.id
      }

      API.request({
        ...API_ROUTER.tournaments.getAuthTournaments,
        urlParams,
        pathKeys: {
          page: pageTournament,
          limit: 10,
        },
      })
        .then(res => {
          setTournamentList(res)
        })
        .catch(err => console.log(err))
        .finally(() => {
          if (isFilterChange) {
            setIsFilterLoading(false)
          } else {
            setIsLoading(false)
          }
        })
    },
    [
      pageTournament,
      defaultGame,
      defaultMonth,
      setTournamentList,
      setIsLoading,
      setIsFilterLoading,
    ]
  )

  return {
    getAuthTournament,
  }
}

export default useGetAuthTournament
